/**
 * https://ant.design/components/input/#components-input-demo-size
 * These apply to Select, Button, etc as well.
 */
const inputSizes = {
  large: 40,
  largePx: "40px",
  medium: 32,
  mediumPx: "32px",
  small: 24,
  smallPx: "24px",
  border: 1,
};

export { inputSizes };
